import { BankDetailsModal } from "../components/Modals/BankDetailsModal";
import { ReasonPickerModal } from "../components/Modals/ReasonPickerModal";
import { TravellerDetailModal } from "../components/Modals/TravellerDetailModal";
import { useClaimModal } from "./ModalContext";
import type { ModalPayloadMap } from "./types";
import { ModalActionId } from "./types";

export function ModalRenderer() {
  const { state, closeModal } = useClaimModal();
  const { activeModal, payload } = state;

  if (activeModal == null || payload == null) {
    return null;
  }

  switch (activeModal) {
    case ModalActionId.ADD_BANK_DETAIL: {
      const { data, onSubmit } =
        payload as ModalPayloadMap[ModalActionId.ADD_BANK_DETAIL];
      return (
        <BankDetailsModal
          data={data}
          onSubmit={onSubmit}
          onClose={closeModal}
        />
      );
    }

    case ModalActionId.OPEN_CLAIM_REASON: {
      const { reasonData, onSelectNode } =
        payload as ModalPayloadMap[ModalActionId.OPEN_CLAIM_REASON];
      return (
        <ReasonPickerModal
          reasonData={reasonData}
          onSelectNode={onSelectNode}
          onClose={closeModal}
        />
      );
    }

    case ModalActionId.VIEW_TRAVELLER_DETAIL: {
      const data =
        payload as ModalPayloadMap[ModalActionId.VIEW_TRAVELLER_DETAIL];
      return <TravellerDetailModal data={data} onClose={closeModal} />;
    }

    default:
      return null;
  }
}
